export default __webpack_public_path__ + "static/media/search_doc.3d6f278a.png";